import { useEffect, useMemo, useState } from "react";
import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";

const useHandler = () => {
  const { get } = useApi();
  const { user } = useSingleton();
  const [boardData, setBoardData] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const course = user?.data?.course;
  const part = user?.data?.part;
  const paper = user?.data?.paper;
  const subject = user?.data?.subject;
  const section = user?.data?.section;
  const classs = user?.data?.clas;

  const ITEMS_PER_PAGE = 5;

  const totalPages = Math.ceil(boardData?.length / ITEMS_PER_PAGE);

  const startItem = (currentPage - 1) * ITEMS_PER_PAGE + 1;

  const endItem = Math.min(currentPage * ITEMS_PER_PAGE, boardData?.length);

  const currentStudents = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;

    return boardData?.slice(start, start + ITEMS_PER_PAGE);
  }, [currentPage, boardData]);

  const API_ENDPOINTS = {
    NEET: {
      leaderboard: `/teacher/exam/stats/users/leaderboard?subject=${subject}`,
    },

    JEE: {
      leaderboard: `/teacher/exam/stats/users/leaderboard?subject=${subject}`,
    },

    UPSC: {
      leaderboard: `/teacher/upsc/stats/users/leaderboard?paper=${paper}`,
    },

    TNPSC: {
      leaderboard: `/teacher/tnpsc/stats/users/leaderboard?part=${part}`,
    },

    Banking: {
      leaderboard: `/teacher/banking/stats/users/leaderboard?section=${section}`,
    },

    CBSE: {
      leaderboard: `/teacher/student/stats/users/leaderboard?subject=${subject}`,
    },

    TN_STATE_BOARD: {
      leaderboard: `/teacher/student/stats/users/leaderboard?subject=${subject}`,
    },
  };

  const api = API_ENDPOINTS[course];

  const getStudentLeaderBoardDetails = async () => {
    try {
      const res = await get(api.leaderboard);
      if (res) {
        setBoardData(res?.data || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM GET TEACHER STUNDETS LAEDERBOARD", e);
    }
  };

  useEffect(() => {
    getStudentLeaderBoardDetails();
  }, []);

  return {
    boardData,
    currentPage,
    startItem,
    endItem,
    totalPages,
    currentStudents,
    currentPage,
    setCurrentPage,
  };
};

export default useHandler;
